const UPPERCASE = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
const LOWERCASE = 'abcdefghijklmnopqrstuvwxyz';
const NUMBERS = '0123456789';
const SPECIAL_CHARS = '!\\#$%&()*+-=?@^_~';

const pickRandom = (chars, count) =>
    Array.from({ length: count }, () => chars[Math.floor(Math.random() * chars.length)]);

// 8 chars from each of the 4 categories → exactly 32. The `length`
// requirement caps at 32, so this picks the maximum strength the
// validator will accept; an even split also guarantees every category
// requirement is satisfied without a separate filler pass.
export function generatePassword() {
    const PER_CATEGORY = 8;

    const chars = [
        ...pickRandom(UPPERCASE, PER_CATEGORY),
        ...pickRandom(LOWERCASE, PER_CATEGORY),
        ...pickRandom(NUMBERS, PER_CATEGORY),
        ...pickRandom(SPECIAL_CHARS, PER_CATEGORY)
    ];

    return chars.sort(() => 0.5 - Math.random()).join('');
}

export function validatePassword(password, passwordConfirmation) {
    const countMatches = pattern => (password.match(pattern) || []).length;

    return {
        length: { met: password.length >= 16 && password.length <= 32, message: i18next.t('ui.passwords.requirements.length') },
        uppercase: { met: countMatches(/[A-Z]/g) >= 2, message: i18next.t('ui.passwords.requirements.upcase') },
        lowercase: { met: countMatches(/[a-z]/g) >= 2, message: i18next.t('ui.passwords.requirements.downcase') },
        number: { met: countMatches(/\d/g) >= 2, message: i18next.t('ui.passwords.requirements.number') },
        specialChar: { met: countMatches(/[!\\#$%&()*+\-=?@^_~]/g) >= 2, message: i18next.t('ui.passwords.requirements.special') },
        passwordConfirmation: { met: password === passwordConfirmation, message: i18next.t('ui.passwords.requirements.match') }
    };
}
